import moment from 'moment'

export const getPlantXML = data => {
  if (!data || data.length === 0) {
    return ''
  }

  const xmlString = []

  xmlString.push('<SolarPlantList>')

  data.forEach(element => {
    xmlString.push('\n\t<SolarPlant>')

    element.entityId &&
      xmlString.push('\n\t\t<EntityID>' + element.entityId + '</EntityID>')
    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.plantName &&
      xmlString.push('\n\t\t<PlantName>' + element.plantName + '</PlantName>')
    element.eiaPlantCode &&
      xmlString.push('\n\t\t<EIACode>' + element.eiaPlantCode + '</EIACode>')
    element.isoResourceId &&
      xmlString.push(
        '\n\t\t<PlantISOID>' + element.isoResourceId + '</PlantISOID>'
      )
    element.country &&
      xmlString.push('\n\t\t<Country>' + element.country + '</Country>')
    element.nearestCity &&
      xmlString.push('\n\t\t<NearCity>' + element.nearestCity + '</NearCity>')
    element.stateProvince &&
      xmlString.push('\n\t\t<State>' + element.stateProvince + '</State>')
    element.timeZone &&
      xmlString.push('\n\t\t<TimeZone>' + element.timeZone + '</TimeZone>')
    element.latitude &&
      xmlString.push(
        '\n\t\t<PlantLatitude>' + element.latitude + '</PlantLatitude>'
      )
    element.longitude &&
      xmlString.push(
        '\n\t\t<PlantLongitude>' + element.longitude + '</PlantLongitude>'
      )
    element.elevationM &&
      xmlString.push('\n\t\t<Elevation>' + element.elevationM + '</Elevation>')
    element.solarRegime &&
      xmlString.push('\n\t\t<SRegime>' + element.solarRegime + '</SRegime>')
    element.globalHIrradiance &&
      xmlString.push('\n\t\t<GHI>' + element.globalHIrradiance + '</GHI>')
    element.interAnnualVarIrr &&
      xmlString.push('\n\t\t<IAVOR>' + element.interAnnualVarIrr + '</IAVOR>')
    element.plantCapPoi &&
      xmlString.push('\n\t\t<CPOI>' + element.plantCapPoi + '</CPOI>')
    element.onSiteStorage &&
      xmlString.push(
        '\n\t\t<OnsiteStorage>' + element.onSiteStorage + '</OnsiteStorage>'
      )
    element.plantOwnershipStatus &&
      xmlString.push(
        '\n\t\t<PlantOwnStatus>' +
          element.plantOwnershipStatus +
          '</PlantOwnStatus>'
      )
    element.effectiveDate &&
      xmlString.push(
        '\n\t\t<PlantEffDate>' +
          moment(element.effectiveDate).format('MM/DD/YYYY') +
          '</PlantEffDate>'
      )

    xmlString.push('\n\t</SolarPlant>')
  })

  xmlString.push('\n</SolarPlantList>')

  return xmlString.join('')
}

export const getEventListXML = data => {
  if (!data || data.length === 0) {
    return ''
  }

  const xmlString = []

  xmlString.push('<EventList>')

  data.forEach(element => {
    xmlString.push('\n\t<Event>')

    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.eventId &&
      xmlString.push('\n\t\t<EventID>' + element.eventId + '</EventID>')
    element.eventstartTimeZone &&
      xmlString.push(
        '\n\t\t<TimeZone>' + element.eventstartTimeZone + '</TimeZone>'
      )
    element.eventstart &&
      xmlString.push('\n\t\t<StartDT>' + element.eventstart + '</StartDT>')
    element.eventend &&
      xmlString.push('\n\t\t<EndDT>' + element.eventend + '</EndDT>')
    element.eventtype &&
      xmlString.push('\n\t\t<EventType>' + element.eventtype + '</EventType>')
    element.causecode &&
      xmlString.push('\n\t\t<CauseCode>' + element.causecode + '</CauseCode>')

    if (element.extension) {
      const extension = element.extension

      xmlString.push('\n\t\t<AdditionalCauseCode>')

      extension.causecode1 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode1 + '</CauseCode>'
        )
      extension.causecode2 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode2 + '</CauseCode>'
        )
      extension.causecode3 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode3 + '</CauseCode>'
        )
      extension.causecode4 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode4 + '</CauseCode>'
        )
      extension.causecode5 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode5 + '</CauseCode>'
        )
      extension.causecode6 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode6 + '</CauseCode>'
        )
      extension.causecode7 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode7 + '</CauseCode>'
        )
      extension.causecode8 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode8 + '</CauseCode>'
        )
      extension.causecode9 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode9 + '</CauseCode>'
        )
      extension.causecode10 &&
        xmlString.push(
          '\n\t\t\t<CauseCode>' + extension.causecode10 + '</CauseCode>'
        )

      xmlString.push('\n\t\t</AdditionalCauseCode>')
    }

    element.contributingCondition &&
      xmlString.push(
        '\n\t\t<Condition>' + element.contributingCondition + '</Condition>'
      )
    element.description &&
      xmlString.push(
        '\n\t\t<Description>' + element.description + '</Description>'
      )
    element.potentialLoss &&
      xmlString.push('\n\t\t<MWHLoss>' + element.potentialLoss + '</MWHLoss>')

    xmlString.push('\n\t</Event>')
  })

  xmlString.push('\n</EventList>')

  return xmlString.join('')
}

export const getInverterGroupXML = data => {
  if (!data || data.length === 0) {
    return ''
  }

  const xmlString = []

  xmlString.push('<SolarInverterGroupList>')

  data.forEach(element => {
    xmlString.push('\n\t<SolarInverterGroup>')

    element.entityId &&
      xmlString.push('\n\t\t<EntityID>' + element.entityId + '</EntityID>')
    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.inverterGroupId &&
      xmlString.push(
        '\n\t\t<InvGroupID>' + element.inverterGroupId + '</InvGroupID>'
      )
    element.inverterGroupName &&
      xmlString.push(
        '\n\t\t<InvGroupName>' + element.inverterGroupName + '</InvGroupName>'
      )
    element.commissionDate &&
      xmlString.push(
        '\n\t\t<InvCommDate>' +
          moment(element.commissionDate).format('MM/DD/YYYY') +
          '</InvCommDate>'
      )
    element.numInverters &&
      xmlString.push(
        '\n\t\t<InverterCount>' + element.numInverters + '</InverterCount>'
      )
    element.singleInvSystemCap &&
      xmlString.push(
        '\n\t\t<InvSystemMW>' + element.singleInvSystemCap + '</InvSystemMW>'
      )

    element.singleInvNameplateCap &&
      xmlString.push(
        '\n\t\t<InvACCap>' + element.singleInvNameplateCap + '</InvACCap>'
      )

    element.invManufacturer &&
      xmlString.push('\n\t\t<InvMfr>' + element.invManufacturer + '</InvMfr>')
    element.invModel &&
      xmlString.push('\n\t\t<InvMdl>' + element.invModel + '</InvMdl>')
    element.scadaManufacturer &&
      xmlString.push(
        '\n\t\t<SCADAMfr>' + element.scadaManufacturer + '</SCADAMfr>'
      )
    element.scadaModel &&
      xmlString.push('\n\t\t<SCADAMdl>' + element.scadaModel + '</SCADAMdl>')
    element.dcInputType &&
      xmlString.push(
        '\n\t\t<InvDCInputType>' + element.dcInputType + '</InvDCInputType>'
      )
    element.dcAcFieldCapRatio &&
      xmlString.push(
        '\n\t\t<InvDCACRatio>' + element.dcAcFieldCapRatio + '</InvDCACRatio>'
      )
    element.panelTrackingType &&
      xmlString.push(
        '\n\t\t<InvPanelTracking>' +
          element.panelTrackingType +
          '</InvPanelTracking>'
      )
    element.panelTiltAngle &&
      xmlString.push(
        '\n\t\t<InvPanelTilt>' + element.panelTiltAngle + '</InvPanelTilt>'
      )
    element.minIrradiance &&
      xmlString.push(
        '\n\t\t<InvMinIrradiance>' +
          element.minIrradiance +
          '</InvMinIrradiance>'
      )
    element.stowingWindSpeed &&
      xmlString.push(
        '\n\t\t<InvStowingSpd>' + element.stowingWindSpeed + '</InvStowingSpd>'
      )
    element.minOpTemperature &&
      xmlString.push(
        '\n\t\t<InvMinOpTemp>' + element.minOpTemperature + '</InvMinOpTemp>'
      )
    element.maxOpTemperature &&
      xmlString.push(
        '\n\t\t<InvMaxOpTemp>' + element.maxOpTemperature + '</InvMaxOpTemp>'
      )
    element.temperatureCoefficient &&
      xmlString.push(
        '\n\t\t<InvTempCoeff>' +
          element.temperatureCoefficient +
          '</InvTempCoeff>'
      )

    element.nameplateEfficiency &&
      xmlString.push(
        '\n\t\t<InvPanelEff>' + element.nameplateEfficiency + '</InvPanelEff>'
      )

    element.invOwnershipStatus &&
      xmlString.push(
        '\n\t\t<InverterOwnStatus>' +
          element.invOwnershipStatus +
          '</InverterOwnStatus>'
      )
    element.effectiveDate &&
      xmlString.push(
        '\n\t\t<InvStatusEffDate>' +
          moment(element.effectiveDate).format('MM/DD/YYYY') +
          '</InvStatusEffDate>'
      )

    xmlString.push('\n\t</SolarInverterGroup>')
  })

  xmlString.push('\n</SolarInverterGroupList>')

  return xmlString.join('')
}

export const getInverterGroupPerformance = data => {
  if (!data || data.length === 0) {
    return ''
  }

  const xmlString = []

  xmlString.push('<InverterGroupPerformanceList>')

  data.forEach(element => {
    xmlString.push('\n\t<InverterGroupPerformance>')

    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.inverterGroupId &&
      xmlString.push('\n\t\t<GroupID>' + element.inverterGroupId + '</GroupID>')
    element.month &&
      xmlString.push('\n\t\t<ReptMonth>' + element.month + '</ReptMonth>')
    element.year &&
      xmlString.push('\n\t\t<ReptYear>' + element.year + '</ReptYear>')
    element.invGroupAvailability &&
      xmlString.push(
        '\n\t\t<InvAvailStatus>' +
          element.invGroupAvailability +
          '</InvAvailStatus>'
      )
    element.grossactgen &&
      xmlString.push('\n\t\t<GAG>' + element.grossactgen + '</GAG>')
    element.netactgen &&
      xmlString.push('\n\t\t<NAG>' + element.netactgen + '</NAG>')
    element.netmaxcap &&
      xmlString.push('\n\t\t<NMC>' + element.netmaxcap + '</NMC>')
    element.monthlyPoa &&
      xmlString.push('\n\t\t<MPOA>' + element.monthlyPoa + '</MPOA>')
    element.performanceRatio &&
      xmlString.push(
        '\n\t\t<PerfRatio>' + element.performanceRatio + '</PerfRatio>'
      )
    element.expectedGen &&
      xmlString.push('\n\t\t<EG>' + element.expectedGen + '</EG>')
    element.activeSolarIh &&
      xmlString.push('\n\t\t<ASIH>' + element.activeSolarIh + '</ASIH>')
    element.activeIh &&
      xmlString.push('\n\t\t<AIH>' + element.activeIh + '</AIH>')
    element.inactiveReserveIh &&
      xmlString.push('\n\t\t<IRIH>' + element.inactiveReserveIh + '</IRIH>')
    element.mothballedIh &&
      xmlString.push('\n\t\t<MBIH>' + element.mothballedIh + '</MBIH>')
    element.retiredIh &&
      xmlString.push('\n\t\t<RIH>' + element.retiredIh + '</RIH>')
    element.serviceIhDay &&
      xmlString.push('\n\t\t<SIHD>' + element.serviceIhDay + '</SIHD>')
    element.rsIh && xmlString.push('\n\t\t<RSIH>' + element.rsIh + '</RSIH>')
    element.foIhDay &&
      xmlString.push('\n\t\t<FOIHD>' + element.foIhDay + '</FOIHD>')
    element.moIhDay &&
      xmlString.push('\n\t\t<MIHD>' + element.moIhDay + '</MIHD>')
    element.poIhDay &&
      xmlString.push('\n\t\t<PIHD>' + element.poIhDay + '</PIHD>')
    element.resourceUnaIhDay &&
      xmlString.push('\n\t\t<RUIHD>' + element.resourceUnaIhDay + '</RUIHD>')
    element.serviceIhNight &&
      xmlString.push('\n\t\t<SIHN>' + element.serviceIhNight + '</SIHN>')
    element.foIhNight &&
      xmlString.push('\n\t\t<FOIHN>' + element.foIhNight + '</FOIHN>')
    element.moIhNight &&
      xmlString.push('\n\t\t<MIHN>' + element.moIhNight + '</MIHN>')
    element.poIhNight &&
      xmlString.push('\n\t\t<PIHN>' + element.poIhNight + '</PIHN>')
    element.resourceUnaIhNight &&
      xmlString.push('\n\t\t<RUIHN>' + element.resourceUnaIhNight + '</RUIHN>')

    xmlString.push('\n\t</InverterGroupPerformance>')
  })

  xmlString.push('\n</InverterGroupPerformanceList>')

  return xmlString.join('')
}

export const getEnergyStoragePerformance = data => {
  if (!data || data.length === 0) {
    return ''
  }

  const xmlString = []

  xmlString.push('<EnergyStoragePerformanceList>')

  data.forEach(element => {
    xmlString.push('\n\t<EnergyStoragePerformance>')

    element.plantId &&
      xmlString.push('\n\t\t<PlantID>' + element.plantId + '</PlantID>')
    element.storageGroupId &&
      xmlString.push('\n\t\t<GroupID>' + element.storageGroupId + '</GroupID>')
    element.month &&
      xmlString.push('\n\t\t<ReptMonth>' + element.month + '</ReptMonth>')
    element.year &&
      xmlString.push('\n\t\t<ReptYear>' + element.year + '</ReptYear>')
    element.storageGroupAvailability &&
      xmlString.push(
        '\n\t\t<SGAvailStatus>' +
          element.storageGroupAvailability +
          '</SGAvailStatus>'
      )
    element.chargeMwh &&
      xmlString.push('\n\t\t<ChgMWh>' + element.chargeMwh + '</ChgMWh>')
    element.dischargeMwh &&
      xmlString.push(
        '\n\t\t<DischgMWh>' + element.dischargeMwh + '</DischgMWh>'
      )
    element.chargeHrs &&
      xmlString.push('\n\t\t<ChgHrs>' + element.chargeHrs + '</ChgHrs>')
    element.dischargeHrs &&
      xmlString.push(
        '\n\t\t<DischgHrs>' + element.dischargeHrs + '</DischgHrs>'
      )
    element.foHrs &&
      xmlString.push('\n\t\t<StorageFOH>' + element.foHrs + '</StorageFOH>')
    element.moHrs &&
      xmlString.push('\n\t\t<StorageMOH>' + element.moHrs + '</StorageMOH>')
    element.poHrs &&
      xmlString.push('\n\t\t<StoragePOH>' + element.poHrs + '</StoragePOH>')

    xmlString.push('\n\t</EnergyStoragePerformance>')
  })

  xmlString.push('\n</EnergyStoragePerformanceList>')

  return xmlString.join('')
}

export const getStorageGroupXML = data => {
  if (!data || data.length === 0) {
    return ''
  }

  const xmlString = []

  xmlString.push('<SolarEnergyStorageList>')
  data.forEach(d => {
    xmlString.push('\n\t<SolarEnergyStorage>')

    xmlString.push('\n\t\t<EntityID>' + d.entityId + '</EntityID>')
    xmlString.push('\n\t\t<PlantID>' + d.plantId + '</PlantID>')
    d.storageGroupId &&
      xmlString.push(
        '\n\t\t<StorageGroupID>' + d.storageGroupId + '</StorageGroupID>'
      )
    d.storageGroupName &&
      xmlString.push(
        '\n\t\t<StorageGroupName>' + d.storageGroupName + '</StorageGroupName>'
      )
    d.storageGroupEiaCode &&
      xmlString.push(
        '\n\t\t<StorageEIACode>' + d.storageGroupEiaCode + '</StorageEIACode>'
      )
    d.storageIsoResourceId &&
      xmlString.push(
        '\n\t\t<StorageISORID>' + d.storageIsoResourceId + '</StorageISORID>'
      )
    d.storageType &&
      xmlString.push('\n\t\t<StorageType>' + d.storageType + '</StorageType>')
    d.nameplateCapacity &&
      xmlString.push(
        '\n\t\t<StorageCap>' + d.nameplateCapacity + '</StorageCap>'
      )
    d.nameplateEnergy &&
      xmlString.push(
        '\n\t\t<StorageEnergy>' + d.nameplateEnergy + '</StorageEnergy>'
      )
    d.connectionType &&
      xmlString.push(
        '\n\t\t<StorageConnType>' + d.connectionType + '</StorageConnType>'
      )
    d.chargeableFromGrid &&
      xmlString.push(
        '\n\t\t<GridCharge>' + d.chargeableFromGrid + '</GridCharge>'
      )
    d.storageManufacturer &&
      xmlString.push(
        '\n\t\t<StorageManuf>' + d.storageManufacturer + '</StorageManuf>'
      )
    d.storageModel &&
      xmlString.push('\n\t\t<StorageModl>' + d.storageModel + '</StorageModl>')
    d.commisionDate &&
      xmlString.push(
        '\n\t\t<StorageCommDate>' + d.commisionDate + '</StorageCommDate>'
      )
    d.storageInvManufacturer &&
      xmlString.push(
        '\n\t\t<StorageInvManuf>' +
          d.storageInvManufacturer +
          '</StorageInvManuf>'
      )
    d.storageInvModel &&
      xmlString.push(
        '\n\t\t<StorageInvModel>' + d.storageInvModel + '</StorageInvModel>'
      )
    d.storageOwnershipStatus &&
      xmlString.push(
        '\n\t\t<StorageOwnStatus>' +
          d.storageOwnershipStatus +
          '</StorageOwnStatus>'
      )
    d.effectiveDate &&
      xmlString.push(
        '\n\t\t<StorageStatusEffDate>' +
          d.effectiveDate +
          '</StorageStatusEffDate>'
      )

    xmlString.push('\n\t</SolarEnergyStorage>')
  })
  xmlString.push('\n</SolarEnergyStorageList>')
  return xmlString.join('')
}
